import React, { useState } from 'react';
import { Button } from '@otp/ui';
import { useAuthContext } from 'src/context/auth.context';
import { useTranslation } from 'react-i18next';
import { QuestionnaireForm } from '../form';
import { Can } from 'src/utils/can';
import { QuestionnaireOrderForm } from '../form-order';
import { DocumentNode } from 'graphql';
import { Actions, AppArea, Subjects } from 'src/graphql/generated/graphql';

interface CreateQuestionnaireButtonProps {
  refetchQueries?: DocumentNode[];
}
export const CreateQuestionnaireButton = ({
  refetchQueries,
}: CreateQuestionnaireButtonProps) => {
  const { t } = useTranslation();
  const { isAdmin } = useAuthContext();
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [openSortModal, setOpenSortModal] = useState(false);
  const [sortId, setSortId] = useState<string | null>();
  const createQuesionnaire = () => {
    setOpenCreateModal(true);
  };

  return (
    <Can I={Actions.Write} a={Subjects.Questionnaires} appArea={AppArea.Wttp}>
      <Button
        variant="contained"
        onClick={createQuesionnaire}
        className={`top-1 right-0 ${!isAdmin ? 'absolute' : ''}`}
      >
        {t('wttp.questionnaire.create')}
      </Button>
      {openCreateModal && (
        <QuestionnaireForm
          title={t('wttp.questionnaire.form.create-questionnaire')}
          refetchQueries={refetchQueries}
          onFinish={(id) => {
            setOpenCreateModal(false);
            setOpenSortModal(true);
            setSortId(id);
          }}
          onClose={() => setOpenCreateModal(false)}
        />
      )}
      {openSortModal && sortId && (
        <QuestionnaireOrderForm
          id={sortId}
          onFinish={() => {
            setOpenSortModal(false);
          }}
          refetchQueries={refetchQueries}
          onClose={() => {
            setOpenSortModal(false);
            setSortId(null);
          }}
        />
      )}
    </Can>
  );
};
